import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography, Paper, Grid, Card } from '@mui/material';
import { useStore } from '../stores';
import DashboardLayout from '../components/layout/DashboardLayout/DashboardLayout';
import StatCard from '../components/common/StatCard';
import RecentActivityCard from '../components/common/RecentActivityCard';
import RecentServicesCard from '../components/common/RecentServicesCardProps';
import DriverMap from '../components/map/DriverMap';

const Dashboard: React.FC = () => {
    const { authStore } = useStore();

    const activeServices = [
        {
            driver: "Driver 1",
            vehiclePlate: "AE43YZ7",
            time: "11:30 AM",
            status: "active" as const,
            onNotify: () => console.log("Notificar a Driver 1"),
            onMoreOptions: () => console.log("Más opciones para Driver 1")
        }
    ];

    const completedServices = [
        {
            driver: "Driver 4",
            vehiclePlate: "ZE43HJ7",
            time: "10:30 AM",
            status: "completed" as const,
            onMoreOptions: () => console.log("Más opciones para Driver 4")
        },
        {
            driver: "Driver 7",
            vehiclePlate: "WW43HJ9",
            time: "09:15 AM",
            status: "completed" as const,
            onMoreOptions: () => console.log("Más opciones para Driver 7")
        },
        {
            driver: "Driver 2",
            vehiclePlate: "WW43HJ9",
            time: "09:18 AM",
            status: "completed" as const,
            onMoreOptions: () => console.log("Más opciones para Driver 2")
        },
        {
            driver: "Driver 2",
            vehiclePlate: "WW43HJ9",
            time: "09:18 AM",
            status: "completed" as const,
            onMoreOptions: () => console.log("Más opciones para Driver 2")
        }
    ];

    return (
        <DashboardLayout>
            <Box>
                <Typography variant="h4" sx={{ mb: 1 }}>
                    Dashboard
                </Typography>

                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6, lg: 8 }}>
                        <Card sx={{ borderRadius: '16px', p: 3, height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center' }}>
                            <StatCard
                                title="Disponibles"
                                value={5}
                                backgroundColor="success.main"
                                backgroundOpacity={0.7}
                                textColor="primary.contrastText"
                            />
                            <StatCard
                                title="En ruta"
                                value={7}
                                backgroundColor="secondary.main"
                                backgroundOpacity={0.7}
                                textColor="primary.contrastText"
                            />
                            <StatCard
                                title="Descanso"
                                value={5}
                                backgroundColor="warning.main"
                                backgroundOpacity={0.7}
                                textColor="primary.contrastText"
                            />
                            <StatCard
                                title="Desconectado"
                                value={3}
                                backgroundColor="text.disabled"
                                backgroundOpacity={0.7}
                                textColor="primary.contrastText"
                            />

                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                        <RecentActivityCard
                            mainMessage="La tasa de cambio fluctuó"
                            secondaryMessage="Recuerda chequear el panel de balances"
                            date="10:40 AM, Martes 15 de julio de 2025"
                            onViewAllClick={() => { }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 12, lg: 8 }}>
                        <DriverMap
                            height="100%"
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 12, lg: 4 }}>
                        <RecentServicesCard
                            activeServices={activeServices}
                            completedServices={completedServices}
                            date="Hoy, 13 Sep 2025"
                        />
                    </Grid>
                </Grid>
            </Box>
        </DashboardLayout >
    );
};

export default observer(Dashboard);